import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TpETLComponentTypeManifest } from '../interfaces';
import { TpETLObjectTypes } from '../../etl-data-types/interfaces';
import { TpETLPipelineComponent, TpETLDryRun, TpETLDryRunComponentResult } from '../../interfaces';
import {
  copyETLDryRunObjectTableColumns,
  createConfigParamTypeExistingColumn,
  ETLDryRunObjectTableAddColumn,
} from '../utils';
import { addDryRunObjectTable, getETLComponentInputObjectTable } from '../../utils';
import { VALTYPES } from '../../../../data/interfaces';
import { CONFIGPARAMTYPES } from '../../../visual-analytics/helpers/configParams';

function performDryRun(dryRun: TpETLDryRun, comp: TpETLPipelineComponent): TpETLDryRunComponentResult {
  const inputTableObj = getETLComponentInputObjectTable(dryRun, comp, 'sourceTable');
  const outputTableObj = addDryRunObjectTable(dryRun, comp.outputObjectIds['result'], comp);
  copyETLDryRunObjectTableColumns(inputTableObj, outputTableObj);

  ETLDryRunObjectTableAddColumn(
    outputTableObj,
    'pubmed_full_article',
    'Full Pubmed Article',
    'The full article from Pubmed (if available)',
    VALTYPES.TEXT,
  );

  return {
    abort: false,
  };
}

export const manifestETLFetchPubMedArticle: TpETLComponentTypeManifest = {
  id: 'PubMedArticleFetch',
  name: 'Fetch Full PubMed Article',
  description: 'Fetch the full Article from PubMed if it is available',
  categoryId: 'source',
  icon: <FontAwesomeIcon icon={['fas', 'file-lines']} />,
  inputs: [
    {
      type: TpETLObjectTypes.TABLE,
      id: 'sourceTable',
      name: 'Source Table ',
      columns: [],
    },
  ],
  outputs: [
    {
      id: 'result',
      name: 'Result table',
      type: TpETLObjectTypes.TABLE,
      description: 'Table with the retrieved Articles',
      columns: [],
    },
  ],
  params: [
    {
      id: 'pubMedIdColumn',
      name: 'Pubmed Id Column',
      description: 'Column where the Pubmed Id is stored',
      paramType: createConfigParamTypeExistingColumn('sourceTable'),
    },
    {
      id: 'extractTables',
      name: 'Extract Tables',
      description: '',
      paramType: {
        configParamTypeId: CONFIGPARAMTYPES.Boolean,
        defaultValue: true,
        label: 'Whether to extract tables from the article',
      },
    },
  ],
  performDryRun,
};
